module.exports = "https://static.wmbcdn.com/uniweb/images/dbd2d12dc1876d1d9d1beb26edfa0313.svg";